<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <h3
                class="font-weight-bold"
                v-text="
                  isDeletePage() != true
                    ? 'Daycare Partner Applications'
                    : 'Deleted Daycare Applications'
                "
              ></h3>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search ... "
                    color="#e60040"
                    hide-details="auto"
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  >
                  </v-text-field>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="status"
                    solo
                    hide-details="auto"
                    rounded
                    @click:clear="(filter.is_active = null), (page = 1)"
                    v-model="filter.is_active"
                    :items="statuses"
                    label="Status"
                    @input="(page = 1), getData()"
                    placeholder="Filter by Active Status"
                    prepend-inner-icon="mdi-toggle-switch"
                    clearable
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-text>
              <section v-if="isLoading" style="height: 575px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else
                fixed-header
                height="575"
                class="striped-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left sr_no">Sr No</th>
                      <th class="text-left" style="min-width: none">Status</th>
                      <th class="text-left" style="min-width: 130px">
                        Requested by
                      </th>
                      <th class="text-left" style="min-width: 95px">
                        Full Name
                      </th>
                      <th class="text-left" style="min-width: 115px">
                        Date of Birth
                      </th>
                      <th class="text-left" style="min-width: none">
                        Phone No
                      </th>
                      <th class="text-left" style="min-width: none">Email</th>
                      <th class="text-left" style="min-width: none">Address</th>
                      <th class="text-left" style="min-width: none">Pincode</th>
                      <th class="text-left" style="min-width: none">Gender</th>
                      <th class="text-left" style="min-width: none">
                        Preferred Work Type
                      </th>
                      <th class="text-left" style="min-width: none">
                        Available Days
                      </th>
                      <th class="text-left" style="min-width: none">
                        Open to Pickup/Drop
                      </th>
                      <th class="text-left" style="min-width: 125px">
                        Is Experienced
                      </th>
                      <th class="text-left" style="min-width: none">
                        Experience Description
                      </th>
                      <th class="text-left" style="min-width: 125px">
                        Is Experienced Day Care
                      </th>
                      <th class="text-left" style="min-width: none">
                        Experienced Day Care Description
                      </th>
                      <th class="text-left" style="min-width: 125px">
                        Is Comfortable with all Sizes
                      </th>
                      <th class="text-left" style="min-width: none">
                        Any Specific Skills
                      </th>
                      <th class="text-left" style="min-width: none">
                        Additional Description
                      </th>
                      <th class="text-left" style="min-width: none">
                        Any Allergies
                      </th>
                      <th class="text-left" style="min-width: none">
                        Limitation Description
                      </th>
                      <th class="text-left" style="min-width: none">
                        Refereces
                      </th>
                      <th class="text-left" style="min-width: 160px">
                        Created At
                      </th>
                      <th class="text-right action_th">Action</th>
                    </tr>
                  </thead>
                  <tbody v-if="daycare_career_requests.length != 0">
                    <tr
                      v-for="(
                        daycare_career_request, i
                      ) in daycare_career_requests"
                      :key="`daycare_career_request_${i}`"
                      :class="{
                        'table-row-even': i % 2 === 0,
                        'table-row-odd': i % 2 !== 0,
                        'table-row-last':
                          daycare_career_requests.length - 1 == i,
                      }"
                    >
                      <td style="min-width: 85px">
                        {{ i + 1 }}
                      </td>
                      <td>
                        <v-tooltip
                          bottom
                          v-if="daycare_career_request.status == 1"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Approved
                            </v-chip>
                          </template>
                          <span>Request has been approved</span>
                        </v-tooltip>
                        <v-tooltip
                          bottom
                          v-if="daycare_career_request.status == 0"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="yellow"
                              text-color="black"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Pending
                            </v-chip>
                          </template>
                          <span>Waiting for Approval</span>
                        </v-tooltip>
                        <v-tooltip
                          bottom
                          v-if="daycare_career_request.status == 2"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Rejected
                            </v-chip>
                          </template>
                          <span>Request has been rejected</span>
                        </v-tooltip>
                      </td>
                      <td>
                        {{ daycare_career_request.request_by.user_name || "" }}
                      </td>
                      <td>{{ daycare_career_request.full_name || "" }}</td>
                      <td style="min-width: 115px">
                        {{ daycare_career_request.date_of_birth || "" }}
                      </td>
                      <td>{{ daycare_career_request.phone_no || "" }}</td>
                      <td>{{ daycare_career_request.email || "" }}</td>
                      <td style="min-width: 130px">
                        {{ daycare_career_request.address || "" }}
                      </td>
                      <td>{{ daycare_career_request.pin_code || "" }}</td>
                      <td>
                        {{
                          daycare_career_request.gender != "2"
                            ? daycare_career_request.gender == "1"
                              ? "MALE"
                              : "FEMALE"
                            : "OTHER" || ""
                        }}
                      </td>
                      <td style="min-width: 120px">
                        {{
                          daycare_career_request.preferred_work_type != "2"
                            ? daycare_career_request.preferred_work_type == "1"
                              ? "FULL TIME"
                              : "PART TIME"
                            : "TEMPORARY" || ""
                        }}
                      </td>
                      <td>
                        {{ daycare_career_request.available_on || "" }}
                      </td>
                      <td>
                        {{
                          daycare_career_request.open_to_pickup_drop == "1"
                            ? "YES"
                            : "NO" || ""
                        }}
                      </td>
                      <td>
                        {{
                          daycare_career_request.is_experienced == "1"
                            ? "YES"
                            : "NO" || ""
                        }}
                      </td>
                      <td style="min-width: 255px">
                        <template
                          v-if="
                            daycare_career_request.experience_description
                              ?.length > 85
                          "
                        >
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <span v-bind="attrs" v-on="on">
                                {{
                                  daycare_career_request.experience_description
                                    ?.length > 85
                                    ? daycare_career_request.experience_description.slice(
                                        0,
                                        85
                                      ) + "..."
                                    : daycare_career_request.experience_description
                                }}
                              </span>
                            </template>
                            <span>{{
                              daycare_career_request.experience_description
                            }}</span>
                          </v-tooltip></template
                        >
                        <template v-else>
                          {{ daycare_career_request.experience_description }}
                        </template>
                      </td>
                      <td>
                        {{
                          daycare_career_request.is_experienced_day_care == "1"
                            ? "YES"
                            : "NO" || ""
                        }}
                      </td>
                      <td style="min-width: 255px">
                        <template
                          v-if="
                            daycare_career_request
                              .experienced_day_care_description?.length > 85
                          "
                        >
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <span v-bind="attrs" v-on="on">
                                {{
                                  daycare_career_request
                                    .experienced_day_care_description.length >
                                  85
                                    ? daycare_career_request.experienced_day_care_description.slice(
                                        0,
                                        85
                                      ) + "..."
                                    : daycare_career_request.experienced_day_care_description
                                }}
                              </span>
                            </template>
                            <span>{{
                              daycare_career_request.experienced_day_care_description
                            }}</span>
                          </v-tooltip></template
                        >
                        <template v-else>
                          {{
                            daycare_career_request.experienced_day_care_description
                          }}
                        </template>
                      </td>
                      <td>
                        {{
                          daycare_career_request.is_commfortable_with_sizes ==
                          "1"
                            ? "YES"
                            : "NO" || ""
                        }}
                      </td>
                      <td style="min-width: 255px">
                        <template
                          v-if="
                            daycare_career_request.commfortable_description
                              ?.length > 85
                          "
                        >
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <span v-bind="attrs" v-on="on">
                                {{
                                  daycare_career_request
                                    .commfortable_description?.length > 85
                                    ? daycare_career_request.commfortable_description.slice(
                                        0,
                                        85
                                      ) + "..."
                                    : daycare_career_request.commfortable_description
                                }}
                              </span>
                            </template>
                            <span>{{
                              daycare_career_request.commfortable_description
                            }}</span>
                          </v-tooltip></template
                        >
                        <template v-else>
                          {{ daycare_career_request.commfortable_description }}
                        </template>
                      </td>
                      <td style="min-width: 255px">
                        <template
                          v-if="
                            daycare_career_request.additional_description
                              ?.length > 85
                          "
                        >
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <span v-bind="attrs" v-on="on">
                                {{
                                  daycare_career_request.additional_description
                                    ?.length > 85
                                    ? daycare_career_request.additional_description.slice(
                                        0,
                                        85
                                      ) + "..."
                                    : daycare_career_request.additional_description
                                }}
                              </span>
                            </template>
                            <span>{{
                              daycare_career_request.additional_description
                            }}</span>
                          </v-tooltip></template
                        >
                        <template v-else>
                          {{ daycare_career_request.additional_description }}
                        </template>
                      </td>
                      <td>
                        {{
                          daycare_career_request.has_allergies == "1"
                            ? "YES"
                            : "NO" || ""
                        }}
                      </td>
                      <td style="min-width: 255px">
                        <template
                          v-if="
                            daycare_career_request.allergies_details?.length >
                            85
                          "
                        >
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <span v-bind="attrs" v-on="on">
                                {{
                                  daycare_career_request.allergies_details
                                    ?.length > 85
                                    ? daycare_career_request.allergies_details.slice(
                                        0,
                                        85
                                      ) + "..."
                                    : daycare_career_request.allergies_details
                                }}
                              </span>
                            </template>
                            <span>{{
                              daycare_career_request.allergies_details
                            }}</span>
                          </v-tooltip></template
                        >
                        <template v-else>
                          {{ daycare_career_request.allergies_details }}
                        </template>
                      </td>
                      <td style="min-width: 380px">
                        <template
                          v-if="
                            daycare_career_request
                              .daycare_career_request_references.length
                          "
                        >
                          <v-expansion-panels class="my-2">
                            <v-expansion-panel>
                              <v-expansion-panel-header
                                color="primary"
                                class="white--text"
                              >
                                List of References
                              </v-expansion-panel-header>
                              <v-expansion-panel-content>
                                <v-simple-table
                                  fixed-header
                                  class="striped-table"
                                >
                                  <template v-slot:default>
                                    <thead>
                                      <tr>
                                        <th style="width: 95">Full name</th>
                                        <th style="width: 85">Relation</th>
                                        <th style="width: 95">Contact</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr
                                        v-for="(
                                          reference, dcrR
                                        ) in daycare_career_request.daycare_career_request_references"
                                        :key="`detail_${dcrR}`"
                                        :class="{
                                          'table-row-even': i % 2 === 0,
                                          'table-row-odd': i % 2 !== 0,
                                          'table-row-last':
                                            daycare_career_request
                                              .daycare_career_request_references
                                              .length -
                                              1 ==
                                            i,
                                        }"
                                      >
                                        <td>{{ reference.full_name }}</td>
                                        <td>{{ reference.relation }}</td>
                                        <td>{{ reference.contact }}</td>
                                      </tr>
                                    </tbody>
                                  </template>
                                </v-simple-table>
                              </v-expansion-panel-content>
                            </v-expansion-panel>
                          </v-expansion-panels>
                        </template>
                        <template v-else> </template>
                      </td>
                      <td style="min-width: 160px">
                        {{ formatDate(daycare_career_request.created_at) }}
                      </td>
                      <td class="text-right" style="min-width: 155px">
                        <v-btn v-can:edit="'daycare_requests'"
                          v-if="daycare_career_request.status === 0"
                          class="ml-2"
                          x-small
                          fab
                          color="success"
                          @click="updateStatus(daycare_career_request.id, 1)"
                        >
                          <v-icon dark>mdi-check</v-icon>
                        </v-btn>
                        <!-- Reject button (only show if status is 0) -->
                        <v-btn v-can:edit="'daycare_requests'"
                          v-if="daycare_career_request.status === 0"
                          class="ml-2"
                          x-small
                          fab
                          color="error"
                          @click="updateStatus(daycare_career_request.id, 2)"
                        >
                          <v-icon dark>mdi-close</v-icon>
                        </v-btn>
                        <template v-if="isDeletePage() != true">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn v-can:delete="'daycare_requests'"
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto ml-2"
                                color="error"
                                @click="OpenWarning(daycare_career_request.id)"
                              >
                                <v-icon dark> mdi-delete </v-icon>
                              </v-btn>
                            </template>
                            <span>Delete this Request</span>
                          </v-tooltip>
                        </template>
                        <template v-else>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn v-can:delete="'daycare_requests'"
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="Restore_this(daycare_career_request.id)"
                              >
                                <v-icon dark> mdi-delete-restore </v-icon>
                              </v-btn>
                            </template>
                            <span>Restore this daycare_career_request</span>
                          </v-tooltip>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="100" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-pagination rounded v-model="page" :length="paginationLength">
              </v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- Status Change Warning Dialog Box -->
      <v-dialog v-model="show_Warning_popUp" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-alert
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Warning!</h1>
                      <br />
                      <h3>
                        Are you sure to
                        {{
                          selected_requested.status == "1"
                            ? "Approve"
                            : "Reject"
                        }}?.
                      </h3>
                      <br />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-btn v-can:edit="'daycare_requests'"
                        color="success"
                        @click="
                          (show_Warning_popUp = false),
                            confirmUpdate(selected_requested)
                        "
                      >
                        Confirm
                      </v-btn>
                    </v-col>
                    <v-col>
                      <v-btn
                        color="red"
                        dark
                        @click="
                          (show_Warning_popUp = false),
                            (selected_requested = {})
                        "
                      >
                        Cancel
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Delete Warning Dialog Box -->
      <v-dialog v-model="deleteDialog" width="550px">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 150px"
                >
                  mdi-delete-alert
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Warning!</h1>
                      <br />
                      <h3>Are you sure you want to delete this?</h3>
                      <br />
                      <v-btn color="grey" dark @click="deleteDialog = false"
                        >Cancel</v-btn
                      >
                      <v-btn
                        color="red"
                        dark
                        class="ml-5"
                        @click="
                          Delete_this(to_be_deleted_id), (deleteDialog = false)
                        "
                        >Delete</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Clear Success Dialog Box -->
      <v-dialog v-model="is_deleted_daycare_career_request" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-empty
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Request deleted successfully.</h3>
                      <br />
                      <v-btn
                        color="success"
                        @click="is_deleted_daycare_career_request = false"
                      >
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Clear Success Dialog Box -->
      <v-dialog v-model="is_restored_daycare_career_request" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-restore
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>DaycareCareerRequest restored successfully.</h3>
                      <br />
                      <v-btn
                        color="success"
                        @click="is_restored_daycare_career_request = false"
                      >
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
export default {
  name: "DaycareCareerRequestsPage",
  data() {
    return {
      filter: {
        search_keyword: "",
        is_active: "",
        show_deleted: false,
      },
      daycare_career_requests: [],
      statuses: [
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],
      ExportDaycareCareerRequestTypes: [],
      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      excel_fields: {
        "Sr No": "sr_no",
        Name: "name",
      },
      isLoading: false,
      isExcelloading: false,
      delete_daycare_career_request: false,
      is_deleted_daycare_career_request: false,
      restore_daycare_career_request: false,
      is_restored_daycare_career_request: false,
      show_Warning_popUp: false,
      pendingRequestId: "",
      is_confirmed_delete: "",
      to_be_deleted_id: "",
      deleteDialog: "",
      selected_requested: {},
    };
  },
  watch: {
    page: "getData",
    $route() {
      this.getData();
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    formatDate(value) {
      if (!value) return "";
      try {
        const d = new Date(value);
        const pad = (n) => String(n).padStart(2, "0");
        const day = pad(d.getDate());
        const month = pad(d.getMonth() + 1);
        const year = d.getFullYear();
        const hours = pad(d.getHours());
        const minutes = pad(d.getMinutes());
        const seconds = pad(d.getSeconds());
        return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
      } catch (e) {
        return value;
      }
    },
    OpenWarning(request_id) {
      console.log("Show Warning");
      this.is_confirmed_delete = false;
      this.to_be_deleted_id = request_id;
      this.deleteDialog = true;
    },
    updateStatus(id, status) {
      this.selected_requested = {
        id: id,
        status: status,
      };
      this.show_Warning_popUp = true;
    },
    async confirmUpdate(selected_requested) {
      let reqID = this.encryptIt(selected_requested.id);

      await axios
        .patch(`/daycare_career_requests/${reqID}`, selected_requested)
        .then(() => {
          this.getData();
        });
      this.show_Warning_popUp = false;
    },
    async getData() {
      this.filter.show_deleted = this.$route.query.open_trash ? 1 : 0;
      this.isLoading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";
      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&show_deleted=" +
        this.filter.show_deleted +
        "&is_active=" +
        this.filter.is_active +
        "&search_keyword=" +
        this.filter.search_keyword;
      await axios
        .get(`daycare_career_requests?${query}`)
        .then((response) => {
          this.daycare_career_requests = response.data.data;
          this.count = response.data.count;
          this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
          this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
        })
        .catch((error) => {
          console.error(error);
          this.isUnAuthorised();
        });
      this.isLoading = false;
    },
    //Generate Excel
    async generateExcel() {
      let query = "search_keyword=" + this.filter.search_keyword;
      let response = await axios.get(`daycare_career_request_exports?${query}`);
      console.log(response.data.data);
      if (response) {
        window.open(`${response.data.data}`, "_blank");
      }
    },
    async Delete_this(id) {
      this.delete_daycare_career_request = true;
      await axios
        .post(`/daycare_career_requests/delete/${this.encryptIt(id)}`)
        .then(() => {
          this.delete_daycare_career_request = false;
          this.is_deleted_daycare_career_request = true;
          this.getData();
        })
        .catch((error) => {
          console.error(error);
          this.isUnAuthorised();
        });
    },
    async Restore_this(id) {
      this.restore_daycare_career_request = true;
      await axios
        .post(`/daycare_career_requests/restore/${this.encryptIt(id)}`)
        .then(() => {
          this.restore_daycare_career_request = false;
          this.is_restored_daycare_career_request = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
          window.location.href = "/auth/login";
        });
    },
  },
};
</script>
